import { render, staticRenderFns } from "./EditGroupModal.vue?vue&type=template&id=2e22002e&scoped=true"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"
import style0 from "./EditGroupModal.vue?vue&type=style&index=0&id=2e22002e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22002e",
  null
  
)

export default component.exports